
import copy from 'copy-to-clipboard'
import store from '@/store';
import Vue from 'vue'
import { MatchFiltersDto, MatchRequest, MatchResultsDto, ProfileUpdatedRequest, SharingRequestMatch, SharingRequestMatchMatchDirectionEnum, UnitDto, UserDto } from '@chainsight/networker-backend-axios-sdk';
import MainLayout from '@/components/MainLayout.vue'
import userManager from '@/user-manager';
import { Editor } from '@toast-ui/vue-editor';
import i18n from '@/plugins/i18n'
import { translateMatches } from '@/utils/translator'

export default Vue.extend({
	name: 'NonLoginSharingMatchResults',
	components: {
		MainLayout,
		// editor: Editor
	},
	data() {
		return {
			SharingRequestMatchMatchDirectionEnum,
			overlay: false,
			writeMessageDialog: false,
			emailDialog: false,
			isCopied: false,
			isRequiredImageError: false,
			isFilterBarOpen: false,
			detailDrawer: false,
			mobileDetailDrawer: false,
			loginPromptDialog: false,
			detailDrawerTimer: null as any,
			currentDetailItem: null as any,
			isFilterDialogOpen: false,
			infoDialog: false,
			isSupplyDescExpanded: false,
			isDemandDescExpanded: false,
			resultNumbers: 0,
			allowResults: 0,
			countriesUpperBound: 3,
			industriesUpperBound: 3,
			firstName: '',
			lastName: '',
			jobTitle: '',
			companyName: '',
			companyWebsiteUrl: '',
			emailContentMarkdownForEdit: '',
			demandDescriptions: [] as string[],
			supplyDescriptions: [] as string[],
			countries: [] as string[],
			industries: [] as string[],
			allCountries: [] as string[],
			matchRequest: {} as MatchRequest,
			matchFilterDto: {} as MatchFiltersDto,
			matchResultDetail: {
				unit: {
					id: 0,
					community: [] as {
						url: string,
						platform: string
					}[]
				}
			} as SharingRequestMatch,
			community: [] as {
				url: string,
				platform: string
			}[],
			booths: [] as { 
				url: string
				name: string 
			}[],
			contactList: [] as UnitDto[],
			contactListRefactor: [] as {
				firstName: string,
				lastName: string,
				title: string[],
				email: string,
				mobilePhone: string,
				community: {
					url: string | null,
					platform: string | null
				}[]
			}[],
			matchResults: {} as MatchResultsDto,
			recommendedAction: {
				id: '' as string,
				title: '' as string,
				summary: '' as string,
				text: '' as string
			},
			userDto: {} as UserDto,
			sharingMatchResults: {
				sharingRequestMatches: [] as SharingRequestMatch[]
			},
			editorOptions: {
				hideModeSwitch: true,
				toolbarItems: [
					['heading', 'bold', 'italic', 'strike'],
					['hr', 'quote'],
					['ul', 'ol', 'task', 'indent', 'outdent'],
					['table', 'link'],
					['code', 'codeblock'],
					['scrollSync'],
				]
			},
			currentPage: 0,
			pageSize: 10,
			isLoadingMore: false,
			hasMorePages: true,
			hasSearched: false,
			// 搜尋進度條相關
			isSearchLoading: false,
			progressValue: 0,
			progressStatusText: '',
			progressInterval: null as any
		};
	},
	computed: {
		trackDto(){
			return store.state.track.trackDto
		},
		user() {
			return store.state.user;
		}
	},
	methods: {
		capitalizeFirst(text: string): string {
			if (!text) return ''
			return text.charAt(0).toUpperCase() + text.slice(1)
		},
		onSearchStarted() {
			this.isSearchLoading = true
			this.progressValue = 0
			this.progressStatusText = String(this.$t('common.progressStatus.analyzingRequest'))

			// 啟動進度條動畫 - 15秒分成4等份
			let startTime = Date.now()

			this.progressInterval = setInterval(() => {
				const elapsed = Date.now() - startTime
				const timer = elapsed / 1000 // 轉換為秒

				if (timer >= 15) {
					// 超過15秒，保持在99%
					this.progressValue = 99
					this.progressStatusText = String(this.$t('common.progressStatus.generatingResults'))
					return
				}

				if (timer <= 3.75) {
					// 第一等分：分析您的需求
					this.progressStatusText = String(this.$t('common.progressStatus.analyzingRequest'))
					this.progressValue = (timer / 3.75) * 24.75  // 0-24.75%
				} else if (timer > 3.75 && timer <= 7.5) {
					// 第二等分：搜尋相關成員
					this.progressStatusText = String(this.$t('common.progressStatus.searchingMembers'))
					this.progressValue = 24.75 + ((timer - 3.75) / 3.75) * 24.75  // 24.75-49.5%
				} else if (timer > 7.5 && timer <= 11.25) {
					// 第三等分：智慧配對中
					this.progressStatusText = String(this.$t('common.progressStatus.smartMatching'))
					this.progressValue = 49.5 + ((timer - 7.5) / 3.75) * 24.75  // 49.5-74.25%
				} else if (timer > 11.25 && timer <= 15) {
					// 第四等分：生成結果
					this.progressStatusText = String(this.$t('common.progressStatus.generatingResults'))
					this.progressValue = 74.25 + ((timer - 11.25) / 3.75) * 24.75  // 74.25-99%
				}
			}, 100)  // 每100ms更新一次，讓動畫更平滑
		},
		onSearchFinished() {
			// 完成動畫 - 與 UserProfile.vue 相同的邏輯
			this.progressValue = 100
			clearInterval(this.progressInterval)
			setTimeout(() => {
				this.isSearchLoading = false
				this.progressValue = 0
				this.progressStatusText = ''
			}, 500)
		},
		normalizedWebsite(url: string) {
			if (!url) return ''; // 沒有網址就回傳空字串
			if (/^https?:\/\//i.test(url)) {
				return url;
			}
			return 'https://' + url;
		},
		isInWebView() {
			const ua = navigator.userAgent;
			return /FBAN|FBAV|Instagram|Line|Messenger|WebView/i.test(ua);
		},
		async login() {
			if (this.isInWebView()) {
				alert(String(this.$t('nonLoginSharingMatchResults.loginError')));
				return;
			}

			localStorage.setItem('LOGIN_TO_PAGE', 'sharing');
			localStorage.setItem('SHARING_REQUEST_ID', this.$route.params.sharingRequestId);

			userManager.signinRedirect();
		},
		async loginForSaveContact(){
			if (this.isInWebView()) {
				alert(String(this.$t('nonLoginSharingMatchResults.loginError')));
				return;
			}

			localStorage.setItem('SHARING_MATCH_ID', this.matchResultDetail.id as string);
			localStorage.setItem('ACTION', 'connect');
			localStorage.setItem('LOGIN_TO_PAGE', 'sharing');
			localStorage.setItem('SHARING_REQUEST_ID', this.$route.params.sharingRequestId);

			userManager.signinRedirect();
		},
		handleEditorChange() {
			const editorInstance = this.$refs.markdownEditor as InstanceType<typeof Editor>;
			this.emailContentMarkdownForEdit = editorInstance.invoke('getMarkdown');
		},
		copy(text) {
			copy(text)
			this.isCopied = true
			setTimeout(() => {
				this.isCopied = false
			}, 1000)
		},
		async getMe(){
			try {
				const resp = await this.api$.authApi.getMe();
				this.userDto = resp.data.data as UserDto;

				// this.fistName = this.userDto.firstName ?? '';
				this.firstName = this.userDto.firstName === 'Guest' ? '' : (this.userDto.firstName ?? '');
				this.lastName = this.userDto.lastName === 'User' ? '' : (this.userDto.lastName ?? '');
				this.jobTitle = this.userDto.companyTitle?.[0] ?? '';
				// this.companyName = this.userDto.companyName ?? '';
				this.companyWebsiteUrl = this.userDto.companyUrl ?? '';

			} catch (e) {
				console.error(e);
			}
		},
		onImageError(item : SharingRequestMatch) {
			if (item.unit && item.unit.entityName) {
				const firstLetter = item.unit.entityName.substring(0, 1).toUpperCase();
				item.unit.avatarUrl = require(`@/assets/business-match/alphabet/alphabet=${firstLetter}.png`);
			} else if(item.unit) {
				item.unit.avatarUrl = require('@/assets/business-match/alphabet/alphabet=Other.png');
			}
		},
		async getMatchRequest(){
			try {
				let getMatchRequestResp
				getMatchRequestResp = await this.api$.businessMatchApi.getMatchRequest(this.$route.params.tmpUserId, this.trackDto?.id? this.trackDto.id : '0')
				this.matchRequest = getMatchRequestResp.data.data
			}catch (error) {
				console.error(error);
			}
		},
		async getSharingMatches(isLoadMore = false){
			if (isLoadMore && !this.hasMorePages) return;
			
			if (isLoadMore) {
				this.isLoadingMore = true;
				this.currentPage++;
			} else {
				this.overlay = true;
				this.currentPage = 0;
				this.hasMorePages = true;
			}
			
			let getSharingMatchesResp
			try {
				getSharingMatchesResp = await this.api$.sharingApi.getSharingMatchesPaginated(
					this.$route.params.sharingRequestId, 
					'',
					this.currentPage,
					this.pageSize
				)
				const newData = getSharingMatchesResp.data.data

				// 處理 tags
				newData.content?.forEach(match => {
					if (match.unit?.tags) {
						const parsed: any = JSON.parse(JSON.stringify(match.unit.tags));
						const chapterValue = parsed.chapter;
						const regionValue = parsed.region;
						const typeValue = parsed.type;

						match.unit.tags = JSON.parse(
							JSON.stringify({
								...(chapterValue != null && { chapter: chapterValue }),
								...(regionValue != null && { region: regionValue }),
								...(typeValue != null && { type: typeValue })
							})
						);
					}
				});

				// 翻譯處理
				if (i18n.locale === 'zh') {
					await translateMatches(newData.content || [], 'zh-Hant')
				} else if (i18n.locale === 'en') {
					await translateMatches(newData.content || [], 'en-US')
				} else if (i18n.locale === 'ja') {
					await translateMatches(newData.content || [], 'ja')
				}
				
				if (isLoadMore) {
					// 追加新資料
					if (!this.sharingMatchResults.sharingRequestMatches) {
						this.sharingMatchResults.sharingRequestMatches = [];
					}
					const newMatches = newData.content || [];
					this.sharingMatchResults.sharingRequestMatches = this.sharingMatchResults.sharingRequestMatches.concat(newMatches);
					this.hasMorePages = newData.content && newData.content.length === this.pageSize;
				} else {
					// 第一次載入或重新載入
					this.sharingMatchResults = {
						sharingRequestMatches: newData.content || []
					}
					this.hasMorePages = newData.content && newData.content.length === this.pageSize;
				}
			} catch (error) {
				console.error(error);
			} finally {
				this.hasSearched = true;
				this.isLoadingMore = false;
				this.overlay = false;
			}
		},
		handleScroll(event: Event) {
			const element = event.target as HTMLElement;
			const scrollHeight = element.scrollHeight;
			const scrollTop = element.scrollTop;
			const clientHeight = element.clientHeight;
			
			// 當滾動到底部附近時載入更多
			if (scrollHeight - scrollTop <= clientHeight + 100) {
				this.loadMore();
			}
		},
		loadMore() {
			if (this.isLoadingMore || !this.hasMorePages) return;
			this.getSharingMatches(true);
		},
		async insertSharingMatchResultDetail(sharingRequestMatch : SharingRequestMatch){
			this.overlay = true
			this.matchResultDetail = sharingRequestMatch
			
			// Clear existing timer if any
			if (this.detailDrawerTimer) {
				clearTimeout(this.detailDrawerTimer)
				this.detailDrawerTimer = null
			}
			
			// Check if this is a different item than currently displayed
			const isDifferentItem = this.currentDetailItem?.id !== sharingRequestMatch.id
			this.currentDetailItem = sharingRequestMatch
			this.community = JSON.parse(JSON.stringify(this.matchResultDetail.unit?.community)) as { url: string; platform: string }[]
			this.booths = JSON.parse(JSON.stringify(this.matchResultDetail.unit?.booths)) as { url: string; name: string }[]
			const allowedPlatforms = ['linkedin', 'twitter', 'whatsapp', 'github'];
			if(this.community){
				this.community = this.community.filter(item => {
					return allowedPlatforms.includes(item.platform);
				});
			}
			this.demandDescriptions = JSON.parse(JSON.stringify(this.matchResultDetail.unit?.demands || "[]")).map((d) => d.description ?? d.description_short ?? d.descriptionShort);
			this.supplyDescriptions = JSON.parse(JSON.stringify(this.matchResultDetail.unit?.supplies || "[]")).map((s) => s.description ?? s.description_short ?? s.descriptionShort);

			this.detailDrawer = true
			this.mobileDetailDrawer = true
			this.startLoginPromptTimer()
			this.overlay = false
		},
		async getContactList(unitId : number){
			let getContactListResp
			try{
				getContactListResp = await this.api$.businessMatchApi.getContactList(this.$route.params.tmpUserId, unitId)
				this.contactList = getContactListResp.data.data

				const allowedPlatforms = ['linkedin', 'twitter', 'whatsapp', 'github'];
				this.contactListRefactor = this.contactList.map(item => {
					if(this.community){
						this.community = this.community.filter(item => {
							return allowedPlatforms.includes(item.platform);
						});
					}
					return {
						firstName: item.firstName as string,
						lastName: item.lastName as string,
						title: item.title as string[],
						email: item.email as string,
						mobilePhone: item.mobilePhone as string,
						community: JSON.parse(JSON.stringify(item.community)).filter(item => {
							return allowedPlatforms.includes(item.platform);
						}) as { url: string | null; platform: string | null }[]
					}
				})
			}catch (error) {
				console.error('Error fetching get contact list:', error);
			}
		},
		async getEmail(matchId){
			this.overlay = true
			this.emailDialog = false

			let fistName = this.firstName.length == 0 ? undefined : this.firstName
			let lastName = this.lastName.length == 0 ? undefined : this.lastName
			let jobTitle = this.jobTitle.length === 0 ? undefined : [this.jobTitle]
			// let companyName = this.companyName.length == 0 ? undefined : this.companyName
			let companyWebsiteUrl = this.companyWebsiteUrl.length == 0 ? undefined : 'https://' + this.companyWebsiteUrl

			const ProfileUpdatedRequest: ProfileUpdatedRequest = {
				firstName: fistName,
				lastName: lastName,
				companyTitle: jobTitle,
				// companyName: companyName,
				companyUrl: companyWebsiteUrl,
				productTrackId: this.trackDto?.id,
				isDelete: this.userDto?.isDelete,
			}

			let getRecommendedActionsResp
			let updateProfileResp
			try{
				updateProfileResp = await this.api$.profileApi.updateProfile(this.$route.params.tmpUserId, ProfileUpdatedRequest)

				getRecommendedActionsResp = await this.api$.businessMatchApi.getRecommendedActions(this.$route.params.tmpUserId, matchId, localStorage.getItem('locale') ?? 'en', this.trackDto?.id? this.trackDto.id : '0')
				this.recommendedAction = getRecommendedActionsResp.data.data

				const editorInstance = this.$refs.markdownEditor as InstanceType<typeof Editor>;
				if(editorInstance){
					editorInstance.invoke('setMarkdown', this.recommendedAction.text as string);
				}else{
					this.emailContentMarkdownForEdit = this.recommendedAction.text as string
				}

				this.emailDialog = true
			}catch (error) {
				console.error(error);
			}
			this.overlay = false
		},
		async downloadCSV(){
			const trackId = this.trackDto?.id || ''
			const tmpUserId = this.$route.params.tmpUserId;
			try {
				const downloadUrl = process.env.VUE_APP_API_BASE_URL+`/api/user/${tmpUserId}/business-match/download-match-results?productTrackId=${trackId}`;
				window.open(downloadUrl, '_blank');
			} catch (error) {
				console.error('Error downloading CSV:', error);
			}
		},
		startLoginPromptTimer() {
			// Clear existing timer if any
			if (this.detailDrawerTimer) {
				clearTimeout(this.detailDrawerTimer)
			}

			// Start 30-second timer
			this.detailDrawerTimer = setTimeout(() => {
				this.detailDrawer = false
				this.mobileDetailDrawer = false
				this.loginPromptDialog = true
			}, 30000)
		},
		clearLoginPromptTimer() {
			if (this.detailDrawerTimer) {
				clearTimeout(this.detailDrawerTimer)
				this.detailDrawerTimer = null
			}
		}
	},
	async created(){
		this.overlay = true
		await this.getSharingMatches(false)
		this.overlay = false
	},
	mounted() {
		// 監聽搜尋事件
		this.eventHub$.$on('searchStarted', this.onSearchStarted)
		this.eventHub$.$on('searchFinished', this.onSearchFinished)
	},
	beforeDestroy() {
		// 移除 eventHub 監聽器
		this.eventHub$.$off('searchStarted', this.onSearchStarted)
		this.eventHub$.$off('searchFinished', this.onSearchFinished)
	},
	watch: {
		'$i18n.locale': {
			immediate: false,
			async handler() {
				this.overlay = true
				if (this.sharingMatchResults.sharingRequestMatches && this.sharingMatchResults.sharingRequestMatches.length > 0) {
					if (i18n.locale === 'zh') {
						await translateMatches(this.sharingMatchResults.sharingRequestMatches, 'zh-Hant')
					} else if (i18n.locale === 'en') {
						await translateMatches(this.sharingMatchResults.sharingRequestMatches, 'en-US')
					} else if (i18n.locale === 'ja') {
						await translateMatches(this.sharingMatchResults.sharingRequestMatches, 'ja')
					}
				}
				this.overlay = false
			}
		},
		detailDrawer(newVal) {
			if (!newVal) {
				// Drawer closed, clear timer
				this.clearLoginPromptTimer()
			}
		}
	}
});
